// LE PRODUIT OFFERT AU CHOIX : LE PANNEAU DE CHOIX, A COMPTEURS
// Les produits offerts d'une offre sont poses d'office dans le panier et regroupes sur une
// ligne (inc/conditions-commerciales.php). Son bouton « Modifier mon produit offert » ouvre un panneau qui glisse
// par-dessus le panier lateral : un compteur par produit, et « Valider mon choix » quand le
// total egale les droits. « Retour au panier » referme sans rien changer. Hors du panier
// lateral (page de commande, page Panier), le bouton ouvre d'abord le panier lateral, par ses
// attributs Bootstrap : ce script n'a alors qu'a ouvrir le panneau.
//
// La repartition est envoyee au serveur, qui revalide et refait les lignes offertes. On
// remplace ensuite les fragments comme le fait la mise a jour de quantite : le panneau
// revient ferme, donc sur le panier, pret pour « Commander ».
jQuery(document).ready(function($) {

	var $declencheur = null;

	function panneau() {
		return $('.panneau-choix-cadeau');
	}

	function offre_ouverte() {
		return panneau().find('.js-choix-cadeau-offre:not([hidden])');
	}

	// Recompte, et met les boutons a l'etat : « + » desactive quand le total atteint les
	// droits (sauf pour un seul droit, ou « + » deplace l'unite), « − » a zero, « Valider »
	// actif seulement quand le total est juste.
	function actualiser($offre) {
		var droits = parseInt($offre.data('droits'), 10);
		var total = 0;

		$offre.find('.js-choix-cadeau-produit').each(function() {
			total += parseInt($(this).attr('data-choisi'), 10);
		});

		$offre.find('.js-choix-cadeau-total').text(total);

		$offre.find('.js-choix-cadeau-produit').each(function() {
			var $produit = $(this);
			var choisi = parseInt($produit.attr('data-choisi'), 10);

			$produit.find('.js-cadeau-quantite').text(choisi);
			$produit.toggleClass('is-selected', choisi > 0);
			$produit.find('.js-cadeau-moins').prop('disabled', choisi <= 0);
			$produit.find('.js-cadeau-plus').prop('disabled', total >= droits && !(droits === 1 && choisi === 0));
		});

		panneau().find('.js-valider-choix-cadeau').prop('disabled', total !== droits);
	}

	function ouvrir_panneau(offre) {
		var $panneau = panneau();
		var $offre = $panneau.find('.js-choix-cadeau-offre[data-offre="' + offre + '"]');

		if (!$offre.length) {
			return;
		}

		$panneau.find('.js-choix-cadeau-offre').prop('hidden', true);
		$offre.prop('hidden', false);

		// On repart des quantites du panier : un retour sans validation les a laissees intactes.
		$offre.find('.js-choix-cadeau-produit').each(function() {
			$(this).attr('data-choisi', $(this).data('quantite'));
		});
		actualiser($offre);

		$panneau.addClass('is-open').attr('aria-hidden', 'false');

		// Le focus attend la fin du glissement, sinon le navigateur fait defiler vers le titre.
		setTimeout(function() {
			$panneau.find('.panneau-choix-cadeau-titre').trigger('focus');
		}, 300);
	}

	function fermer_panneau() {
		panneau().removeClass('is-open').attr('aria-hidden', 'true');

		if ($declencheur && $declencheur.is(':visible')) {
			$declencheur.trigger('focus');
		}
	}

	// Le panier lateral qui s'ouvre depuis la page de commande ou la page Panier met un
	// instant a glisser : on ouvre le panneau une fois le panier affiche.
	$(document.body).on('click', '.js-ouvrir-choix-cadeau', function(event) {
		event.preventDefault();

		var $bouton = $(this);
		var offre = String($bouton.data('offre'));
		var panier = document.getElementById('panierLateral');

		$declencheur = $bouton;

		if ($bouton.is('[data-bs-toggle]') && panier && !panier.classList.contains('show')) {
			$(panier).one('shown.bs.offcanvas', function() {
				ouvrir_panneau(offre);
			});
			return;
		}

		ouvrir_panneau(offre);
	});

	$(document.body).on('click', '.js-fermer-choix-cadeau', function() {
		fermer_panneau();
	});

	// Le panier lateral referme (croix, Echap, clic a cote) : le panneau se referme avec lui.
	$(document).on('hidden.bs.offcanvas', '#panierLateral', function() {
		panneau().removeClass('is-open').attr('aria-hidden', 'true');
	});

	$(document.body).on('click', '.js-cadeau-plus', function() {
		var $produit = $(this).closest('.js-choix-cadeau-produit');
		var $offre = $produit.closest('.js-choix-cadeau-offre');

		// Un seul droit : choisir un autre produit y deplace l'unite.
		if (parseInt($offre.data('droits'), 10) === 1) {
			$offre.find('.js-choix-cadeau-produit').attr('data-choisi', 0);
		}

		$produit.attr('data-choisi', parseInt($produit.attr('data-choisi'), 10) + 1);
		actualiser($offre);
	});

	$(document.body).on('click', '.js-cadeau-moins', function() {
		var $produit = $(this).closest('.js-choix-cadeau-produit');

		$produit.attr('data-choisi', Math.max(0, parseInt($produit.attr('data-choisi'), 10) - 1));
		actualiser($produit.closest('.js-choix-cadeau-offre'));
	});

	$(document.body).on('click', '.js-valider-choix-cadeau', function() {
		var $panneau = panneau();
		var $offre = offre_ouverte();
		var donnees = {
			action: 'definir_cadeaux_commerciaux',
			nonce: $offre.data('nonce'),
			offre: $offre.data('offre')
		};

		if (!$offre.length || $panneau.hasClass('is-loading')) {
			return;
		}

		$offre.find('.js-choix-cadeau-produit').each(function() {
			var choisi = parseInt($(this).attr('data-choisi'), 10);
			if (choisi > 0) {
				donnees['repartition[' + $(this).data('produit') + ']'] = choisi;
			}
		});

		$panneau.addClass('is-loading');

		$.ajax({
			type: 'POST',
			url: $offre.data('ajax'),
			data: donnees,
			success: function(response) {
				if (!response || !response.success) {
					$panneau.removeClass('is-loading');
					if (response && response.data && response.data.message) {
						window.alert(response.data.message);
					}
					return;
				}

				$.each(response.data.fragments, function(selector, html) {
					$(selector).replaceWith(html);
				});
				$(document.body).trigger('wc_fragments_refreshed');

				// La page de commande relit son recapitulatif.
				if ($(document.body).hasClass('woocommerce-checkout')) {
					$(document.body).trigger('update_checkout');
				}

				// La page Panier se recharge : le bloc ne relit pas le panier de lui-meme, et la
				// ligne de rappel posee au-dessus de lui est rendue par le serveur.
				if ($(document.body).hasClass('woocommerce-cart')) {
					window.location.reload();
				}
			},
			error: function() {
				$panneau.removeClass('is-loading');
			}
		});
	});
});
